export const PUSH_ALERT = 'alert:push';
export const REMOVE_ALERT = 'alert:remove';
export const CLEAR_ALERTS = 'alert:clear';
